import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { Card, CardContent } from '@/components/ui/card';
import { ChevronDown, TrendingUp, Activity, BarChart3, Volume2 } from 'lucide-react';
import { useState } from 'react';

export function HowItWorks() {
  const [open, setOpen] = useState(false);

  const filters = [
    {
      icon: TrendingUp,
      title: 'EMA Alignment',
      description: 'Price must be above both the 50-day and 200-day Exponential Moving Averages. A "Golden Cross" (50 EMA above 200 EMA) signals strong bullish momentum.',
    },
    {
      icon: Activity,
      title: 'MACD Crossover',
      description: 'The MACD line must have crossed above the Signal line within the last 3 days. This confirms a fresh momentum shift — the earlier the crossover, the higher the score.',
    },
    {
      icon: BarChart3,
      title: 'RSI Sweet Spot',
      description: 'RSI(14) must be between 40 and 65. This range means momentum is building without being overbought. Peak score at RSI 50.',
    },
    {
      icon: Volume2,
      title: 'Volume Surge',
      description: '24-hour volume must exceed 120% of the 10-day average. Rising volume confirms that the price move has conviction behind it.',
    },
  ];

  return (
    <Collapsible open={open} onOpenChange={setOpen}>
      <CollapsibleTrigger className="w-full">
        <Card className="bg-card border-border hover:border-primary/30 transition-colors cursor-pointer">
          <CardContent className="p-4 flex items-center justify-between">
            <span className="font-semibold">How This Screener Works</span>
            <ChevronDown className={`w-5 h-5 text-muted-foreground transition-transform ${open ? 'rotate-180' : ''}`} />
          </CardContent>
        </Card>
      </CollapsibleTrigger>
      <CollapsibleContent>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-3">
          {filters.map((f) => (
            <Card key={f.title} className="bg-card/50 border-border/50">
              <CardContent className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <f.icon className="w-4 h-4 text-primary" />
                  <h4 className="font-semibold text-sm">{f.title}</h4>
                </div>
                <p className="text-xs text-muted-foreground leading-relaxed">{f.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
        <p className="text-xs text-muted-foreground mt-3 text-center">
          A token must pass <strong>all four filters</strong> to appear as a top opportunity. Tokens passing 2-3 filters appear on the Watchlist.
        </p>
      </CollapsibleContent>
    </Collapsible>
  );
}
